import { useContext, useEffect, useState } from 'react';
import { EntryContext } from '../contexts/entryContext';
import axios from 'axios';

const useIGRGameUrl = (revealGame) => {
    const { entry, igrAuthToken } = useContext(EntryContext);
    const [gameUrl, setGameUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchGameUrl = async () => {
            if (!entry || !igrAuthToken || !revealGame?.game_id) {
                setLoading(false);
                return;
            }

            const alreadyPlayed = !!entry?.TicketDetails?.RevealGameId;

            const gameOptions = {
                gameId: revealGame?.game_id,
                serverType: 'Static',
                outcomeData: {
                    prizeType: entry?.TicketDetails?.PrizeType,
                    instantSkip: alreadyPlayed,
                    seed: entry?.TicketDetails?.ValidationNumber,
                },
                ticketLink: revealGame?.callToActionURL ?? '',
                useMinimized: false,
            };

            const gameData = encodeURIComponent(JSON.stringify(gameOptions));

            try {
                setLoading(true);
                const response = await axios.post(`${igrAuthToken?.config?.url}/api/games/url?token=${igrAuthToken?.credentials}`, {
                    options: gameData,
                });
                //? For debug: console.log('🚒 options', gameOptions, response?.data);
                setGameUrl(response?.data?.gameUrl);
            } catch (err) {
                //? For debug: console.log('🔴 Game error:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchGameUrl();
    }, [entry, igrAuthToken, revealGame?.game_id, revealGame?.callToActionURL]);

    return { gameUrl, loading, error };
};

export default useIGRGameUrl;
